var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState, useRef, useEffect } from "react";
import clsx from "clsx";
import { createStyles, InputBase, makeStyles, IconButton, InputAdornment } from "@material-ui/core";
import { useHeaderConfig } from "../../NavProvider";
import { interpolate } from "../../../../lib/utils";
import { SearchCloseIcon, SearchIcon, SearchResetIcon } from "../../../icons";
import { trackSearchEvent } from "../analytics";
var useStyles = makeStyles(createStyles({
    root: {
        fontSize: 16,
        lineHeight: "22px",
    },
    input: {
        height: 22,
        padding: 0,
        caretColor: "#1d7fe3",
        WebkitAppearance: "none",
        "&::-webkit-search-cancel-button": {
            WebkitAppearance: "none",
        },
    },
    icon: {
        padding: 0,
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
}));
var SearchInput = function (props) {
    var _a = props.classes, outerClasses = _a === void 0 ? {} : _a, mobile = props.mobile, focus = props.focus, otherProps = __rest(props, ["classes", "mobile", "focus"]);
    var styles = useStyles();
    var ref = useRef(null);
    var searchConfig = useHeaderConfig().search;
    var placeholder = searchConfig.placeholder, endpoint = searchConfig.endpoint;
    var _b = useState(""), searchInput = _b[0], setSearchInput = _b[1];
    var classes = __assign(__assign({}, outerClasses), { root: clsx(styles.root, outerClasses.root), input: clsx(styles.input, outerClasses.input) });
    var handleKeyDown = useCallback(function (event) {
        if (event.key === "Enter") {
            event.stopPropagation();
            event.preventDefault();
            var value = event.currentTarget.value;
            if (value && value.trim()) {
                trackSearchEvent(value);
                var q = encodeURIComponent(value);
                window.location.href = interpolate(endpoint, { q: q });
            }
        }
    }, [endpoint]);
    var handleChange = function (event) {
        setSearchInput(event.target.value);
    };
    var handleClick = useCallback(function () {
        var _a;
        if (searchInput)
            setSearchInput("");
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [searchInput, ref]);
    useEffect(function () {
        var _a;
        if (focus) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
            setSearchInput("");
        }
    }, [focus, ref]);
    var closeIcon = mobile ? React.createElement(SearchCloseIcon, null) : React.createElement(SearchResetIcon, null);
    return (React.createElement(InputBase, __assign({ id: "acm-header__searchbar", classes: classes, placeholder: placeholder, value: searchInput, onChange: handleChange, onKeyDown: handleKeyDown, autoComplete: "off", inputProps: { type: "search" }, inputRef: ref, endAdornment: React.createElement(InputAdornment, { position: "end" },
            React.createElement(IconButton, { className: styles.icon, onClick: handleClick, disableRipple: true }, searchInput ? closeIcon : mobile && React.createElement(SearchIcon, { color: "#b2b3b8" }))) }, otherProps)));
};
export default SearchInput;
